import i18nFactory from '@yandex-int/i18n';
import { Action } from 'redux';
import { Epic, ofType } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import {
    UpdateInternalProduct,
    updateInternalProductAction
} from '../../../../actions/products/internal/updateInternalProduct';
import {
    UPDATE_INTERNAL_PRODUCT_DESCRIPTION,
    UpdateInternalProductDescription
} from '../../../../actions/products/internal/updateInternalProductDescription';
import {
    UpdateInternalProductsPageStatus,
    updateInternalProductsPageStatusAction
} from '../../../../actions/products/internal/updateInternalProductsPageStatus';
import { mapTextToErrors } from '../../../../service/ErrorsMapper/ErrorsMapper';
import { showNoticeMessage } from '../../../../service/GridHelpers/GridHelpers';
import { internalProductsErrorsMapper } from '../../../../service/InternalToolsErrorsMappers/InternalToolsErrorsMappers';
import { EpicDeps } from '../../../../service/StoreFactory';
import { NoticeType } from '../../../../typings/grid';
import { ProductsPageStates } from '../../../../typings/products';
import { State } from '../../../../typings/state';

import * as keyset from './updateInternalProductDescriptionEpic.i18n';

const i18n = i18nFactory(keyset);

type SaveInternalProductDescriptionEpicActions = UpdateInternalProduct | UpdateInternalProductsPageStatus;

export const updateInternalProductDescriptionEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) =>
    action$.pipe(
        ofType(UPDATE_INTERNAL_PRODUCT_DESCRIPTION),
        mergeMap(
            (action: UpdateInternalProductDescription): Observable<SaveInternalProductDescriptionEpicActions> => {
                return from(deps.productsDataProvider.updateDescription(action.product)).pipe(
                    mergeMap(response => {
                        showNoticeMessage(NoticeType.success, i18n('success-change'));

                        return of(
                            updateInternalProductAction(response),
                            updateInternalProductsPageStatusAction(ProductsPageStates.LOADED)
                        );
                    }),
                    catchError(e => {
                        const errorsClientWithText = mapTextToErrors(e.errors, internalProductsErrorsMapper);
                        showNoticeMessage(NoticeType.error, errorsClientWithText[0].text);

                        return of(updateInternalProductsPageStatusAction(ProductsPageStates.PENDING));
                    })
                );
            }
        )
    );
